class HomeWarranty extends HTMLElement {
	constructor() {
		super();
		this.particles = [];
		this.canvas = null;
		this.dpr = window.devicePixelRatio || 1;
	}
	connectedCallback() {
		this.init();
	}
	init() {
		this.setup();
	}
	setup() {
		new MasterTimeline({
			triggerInit: this,
			scrollTrigger: { trigger: this.querySelector('.home-warranty'), start: 'top 80%' },
			tweenArr: [
				new ScaleLine({ el: this.querySelector('.home-warranty-line-top') }),
				new RevealText({ el: this.querySelector('.home-warranty-title .txt'), color: 'black' }),
				new FadeIn({ el: this.querySelector('.home-warranty-btn'), from: { y: parseRem(20) } }),
				...Array.from(this.querySelectorAll('.home-warranty-privilege-item')).flatMap((item, idx) => {
                    let delayI = (index, initDelay = .1) => (index !== 0 ? initDelay * (index + 1) : initDelay);
                    return [
                        new ScaleInset({ el: item.querySelector('.home-warranty-privilege-item-ic'), delay: delayI(idx) }),
                        new FadeSplitText({ el: item.querySelector('.home-warranty-privilege-item-content .txt'), delay: delayI(idx, 0.15) }),
                    ];
                })
			]
		})
	}
	createExplosion(x, y) {
		if (window.innerWidth < 991) return;

		const particleCount = 14; // 20/3
		const maxSize = parseRem(50);
		const minSize = parseRem(17);

		for (let i = 0; i < particleCount; i++) {
			const size = Math.max(minSize, Math.min(Math.random() * maxSize, maxSize));
			const speedY = -((particleCount * 3) / size);
			const direction = Math.random() > 0.5 ? 1 : -1;
			const speedX = direction * (size / particleCount);
			x = Math.max(size, i * ((this.canvas.width - size) / particleCount));
			y = Math.min(parseRem(250), Math.max(parseRem(180), y)) + (direction * size) / 2;
			let particles = new Particle(x, y * this.dpr, size * this.dpr, speedX, speedY * this.dpr, this.canvas, i)
			this.particles.push(particles);
		}
	}
	setupCanvasEmoji() {
		if (window.innerWidth < 991) return;
		const dpr = window.devicePixelRatio || 1;

		function createHiDPICanvas(width, height) {
			const canvas = document.createElement("canvas");

			canvas.width = width * dpr;
			canvas.height = height * dpr;
			canvas.style.width = width + "px";
			canvas.style.height = height + "px";
			canvas.getContext("2d").scale(dpr, dpr);

			return canvas;
		}

		const canvasWrap = document.querySelector("#home-stats-item-title-canvas");
		const canvas = createHiDPICanvas(canvasWrap.clientWidth, canvasWrap.clientHeight);
		canvasWrap.appendChild(canvas);
		this.canvas = canvas;
		const ctx = canvas.getContext("2d");

		function resizeCanvas() {
			canvas.width = canvasWrap.clientWidth * dpr;
			canvas.height = canvasWrap.clientHeight * dpr;
			canvas.style.width = canvas.width + 'px';
			canvas.style.height = canvas.height + 'px';
		}

		const animate = () => {
			if (isInViewport(canvasWrap)) {
				ctx.clearRect(0, 0, canvas.width, canvas.height);
				this.particles.filter(particle => {
					particle.update();
					particle.draw();
					return particle.size > 0.5;
				});
			}
			requestAnimationFrame(animate);
		};
		// Initialize
		resizeCanvas();
		animate();
		window.addEventListener("resize", resizeCanvas);


		this.querySelector(".home-start-wrap-canvas canvas")
			.addEventListener("mouseenter", e => {
				const isAnimated = this.particles.every(par => par.animated);
				// console.log('isAnimated', isAnimated);
				if (isAnimated) {
					this.createExplosion(e.offsetX, e.offsetY);
				}
		});
	}
}
customElements.define("home-warranty", HomeWarranty);
